import { RootCauseDivergedBarGraphGroupResult } from 'libs/end-to-end/src/root-cause-analysis';
import { yAxisDivergedBarGraph } from 'libs/end-to-end/src/root-cause-analysis';
import React from 'react';
import { DisparityBarChart } from 'apps/sigma2-ui/src/pages/FocusAreaPage/DisparityBarChart';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { GraphLegend } from 'apps/sigma2-ui/src/components/ui/GraphLegend';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { convertTranslatedContentToReactNode } from 'apps/sigma2-ui/src/lib/hooks/useTranslation';

interface RootCauseDisparityBarChartProps {
  controlVariableDisplay: string;
  download: React.ReactNode;
  groupResult: RootCauseDivergedBarGraphGroupResult;
  treatmentLevel: string;
  yAxisText: string;
  graphClassName: string;
}

export const RootCauseDisparityBarChart = ({
  controlVariableDisplay,
  download,
  groupResult,
  treatmentLevel,
  yAxisText,
  graphClassName,
}: RootCauseDisparityBarChartProps) => {
  const language = useLanguage();

  return (
    <>
      <div className="pl-[100px] pr-12 mb-4">
        <Spacing direction="horizontal" size="justify-between">
          <Spacing
            direction="horizontal"
            size="lg"
            className="w-full justify-center"
          >
            <GraphLegend
              color="#076DD3"
              key="insightDisparityBarChartWithoutControlVariable"
            >
              {convertTranslatedContentToReactNode(language.insightDisparityBarChartWithoutControlVariable({
                controlVariable: controlVariableDisplay,
              }))}
            </GraphLegend>

            <GraphLegend
              color="#CE106F"
              key="insightDisparityBarChartWithControlVariable"
            >
              {convertTranslatedContentToReactNode(language.insightDisparityBarChartWithControlVariable({
                controlVariable: controlVariableDisplay,
              }))}
            </GraphLegend>
          </Spacing>

          {download}
        </Spacing>
      </div>
      <div className={graphClassName}>
        <DisparityBarChart
          result={groupResult}
          controlVariable={groupResult.control_variable}
          demographicKey={treatmentLevel}
          yAxisText={yAxisText}
        />
      </div>
    </>
  );
};
